//Libraries
import _ from 'lodash';
import moment from 'moment';
import axios from 'axios';

//Components
import Section from '../../components/section';
import Header from '../../components/pageHeader';
import LongPress from '../../components/longPress';
import SectionSpacing from '../../components/sectionSpacing';
import { AiOutlineEdit } from "react-icons/ai";
import { AiOutlineDelete } from "react-icons/ai";

//Styling
import './news.scss'
import '../../dashboard.scss';
import colours from './../../utilities/colours.scss';

//Functions and Data
import config from './config';
import baseconfig from '../../../../variables/config';
import React, { useEffect, useState, useCallback } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { fetchClasses } from '../../../../modules/classes';
import { sendRequest } from '../../../../modules/admin';
import { isEqualDate, keys } from '../../utilities/calendarData.js';
import S3 from 'react-aws-s3';
import Dropzone from 'react-dropzone'


function News({ isOpen, sendRequest, news }) {
  const [tab, setTab] = useState(0)
  const [tabs, setTabs] = useState([]);
  const [showNews, setShowNews] = useState([]);
  const [toggle, setToggle] = useState("")
  const [toggle2, setToggle2] = useState("")
  const [image, setImage] = useState("")
  const [content, setContent] = useState("")
  const [points, setPoints] = useState([])
  const [point, setPoint] = useState("")
  const [editSwitch, setEditSwitch] = useState(-1)

  useEffect(() => {
    sendRequest(fetchClasses);
    fetchNewsList();
    var cb = (i) => setTab(i);
    setTabs([{ name: '', cb: () => cb(0) }]);
  }, [])

  const config = {
    bucketName: 'wackykingdom',
    dirName: 'media', /* optional */
    region: 'eu-west-2',
    accessKeyId: process.env.REACT_APP_S3Key,
    secretAccessKey: process.env.REACT_APP_S3SecretAccessKey,
    s3Url: 'https://wackykingdom.s3.eu-west-2.amazonaws.com', /* optional */
  }

  const uploadImage = (file) => {
    const ReactS3Client = new S3(config);
    /*  Notice that if you don't provide a dirName, the file will be automatically uploaded to the root of your bucket */

    /* This is optional */
    const newFileName = 'news-' + JSON.stringify(Date.now()) + '-' + file[0].name;

    ReactS3Client
      .uploadFile(file[0], newFileName)
      .then(data => {
        const news = [...showNews];
        news[editSwitch].image = data.location;
        setImage(data.location);
        setShowNews(news)
      })
      .catch(err => console.error(err))

    /**
     * {
     *   Response: {
     *     bucket: "myBucket",
     *     key: "image/test-image.jpg",
     *     location: "https://myBucket.s3.amazonaws.com/media/test-file.jpg"
     *   }
     * }
     */
  }


  const newsStructure = {
    isInternal: true,
    articleText: [
    ],
    hasButton: false,
    buttonDetails: {
      action: "link",
      content: "Add Detail",
      contentName: "Add Detail",
      isInternal: true,
      buttonText: "Add Detail"
    },
    image: "none",
    title: "Add Detail",
    date: "Add Detail",
    desc: "Add Detail",
    link: "articles/Add Link",
    author: "Add Detail"
  }

  const fetchNewsList = async () => {
    let token = JSON.parse(window.localStorage.getItem('userData')).token;
    const newsData = (await axios.get(baseconfig.serverURL + '/NewsArticles' + '?access_token=' + token)).data;
    setShowNews(newsData);
  }

  const addNews = () => {
    var newNews = [...showNews];
    newNews.push(newsStructure);
    setShowNews(newNews);
  }

  const updateNews = async (i) => {

    if (!showNews[i].id) {
      let token = JSON.parse(window.localStorage.getItem('userData')).token;
      let response = {};
      try {
        response = await axios.post(baseconfig.serverURL + '/NewsArticles', showNews[i]);
        setEditSwitch(-1);
        fetchNewsList();
      } catch (err) {
        if (response.data.status === "success") {
          console.log("response ok");
        } else {
          throw new Error("Please fill all fields");
        }
      }
    } else {
      let token = JSON.parse(window.localStorage.getItem('userData')).token;
      let response = {};
      try {
        response = await axios.patch(baseconfig.serverURL + '/NewsArticles/' + showNews[i].id + '?access_token=' + token, showNews[i]);
        console.log("response ok");
        setEditSwitch(-1);
        fetchNewsList();
      } catch (err) {
        if (response.data.status === "success") {
          console.log("response ok");
        } else {
          throw new Error("Please fill all fields");
        }
      }
    }
  }


  const deleteNews = async (i) => {
    if (window.confirm("Are you sure you want to delete?")) {
      let token = JSON.parse(window.localStorage.getItem('userData')).token;
      let response = [];
      try {
        response = await axios.delete(baseconfig.serverURL + '/NewsArticles/' + showNews[i].id + '?access_token=' + token);
        console.log("response ok");
        setEditSwitch(-1);
        fetchNewsList();
      } catch (err) {
        if (response.data.status === "success") {
          console.log("response ok");
        } else {
          throw new Error(response.data.error);
        }
      }
    } else {
      console.log("cancel ok");
    }


  }

  const handleContent = (event) => {

    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    setContent(value);
  }

  const handlePoints = (event) => {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;
    const newPoint = [...point];
    newPoint.push(value);
    setPoints(newPoint);
  }

  const handleChange = (event, index) => {

    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;
    var newData = { ...showNews[editSwitch] };
    var newNews = [...showNews];

    newData[name] = value;
    newNews[editSwitch] = newData;
    setShowNews(newNews)
  }

  const handleChangeArrayType = (event, index) => {
    const target = event.target;
    const value = target.value;
    const name = target.name;
    var newData = { ...showNews[editSwitch] };
    var newNews = [...showNews];

    newData[name][index] = value;
    newNews[editSwitch] = newData;
    setShowNews(newNews)
  }

  const handleChangeArrayType2 = (event, index, j) => {
    const target = event.target;
    const value = target.value;
    const name = target.name;
    var newData = { ...showNews[editSwitch] };
    var newNews = [...showNews];

    newData[name][index][j] = value;
    newNews[editSwitch] = newData;
    setShowNews(newNews)
  }

  const removePara = (type, index) => {
    var newData = { ...showNews[editSwitch] };
    var newNews = [...showNews];

    newData[type].splice(index, 1);
    newNews[editSwitch] = newData;
    setShowNews(newNews);
  }

  const removeList = (type, index, j) => {
    var newData = { ...showNews[editSwitch] };
    var newNews = [...showNews];

    newData[type][index].splice(j, 1);
    newNews[editSwitch] = newData;
    setShowNews(newNews);
  }



  const handleChangeType = (event, type) => {
    const target = event.target;
    const value = target.value;
    const name = target.name;
    var newNews = [...showNews];
    newNews[editSwitch][type][name] = value;

    setShowNews(newNews);
  }

  const addContent = (option, i) => {
    var newNews = [...showNews];
    newNews[i][option].push(content);
    setShowNews(newNews);
    setToggle('');
    setContent('');
  }

  const addPoints = (option, i) => {
    var newNews = [...showNews];
    newNews[i][option].push(points);
    setShowNews(newNews);
    setToggle2('');
    setPoints([]);
  }

  const addPoint = () => {
    const newList = [...points];
    newList.push(point);
    setPoint("");
    setPoints(newList);
  }



  var newsList = showNews.map((item, index) => (
    <div className='orderContent' key={index}>
      {editSwitch === index ?
        <li>
          <label>Internal News:</label>
          <label className="switch">
            <input type="checkbox" name="isInternal" checked={item.isInternal} onChange={handleChange} />
            <span className="slider round"></span>
          </label>
          <br />
          <span>
            <label>Title:</label>
            <input value={item.title} name="title" className="column" placeholder="title" onChange={handleChange} />
          </span>
          <br />
          <span>
            <label>Date:</label>
            <input value={item.date} name="date" className="column" placeholder="" onChange={handleChange} />
          </span>
          <br />
          <span>
            <label>Desc:</label>
            <input value={item.desc} name="desc" className="column" placeholder="" onChange={handleChange} />
          </span>
          <br />
          <span>
            <label>Link:</label>
            <input value={item.link} name="link" className="column" placeholder="" onChange={handleChange} />
          </span>
          <span>
            <label>Author:</label>
            <input value={item.author} name="author" className="column" placeholder="" onChange={handleChange} />
          </span>
          <br />
          <span>
            <label>Image:</label>
            <input value={item.image} name="image" className="column" placeholder="" onChange={handleChange} />
          </span>
          <Dropzone onDrop={acceptedFiles => uploadImage(acceptedFiles)}>
            {({ getRootProps, getInputProps }) => (
              <section>
                <div {...getRootProps()}>
                  <input {...getInputProps()} />
                  <button>Upload Image</button>
                </div>
              </section>
            )}
          </Dropzone>
          <br />

          <label>Has Button:</label>
          <label className="switch">
            <input type="checkbox" name="hasButton" checked={item.hasButton} onChange={handleChange} />
            <span className="slider round"></span>
          </label>
          <br />
          <span className="list">
            <label>Button Details -  </label>
            <span className="column">
              <label> Button Action:</label>
              <input value={item.buttonDetails.action} name="action" onChange={event => handleChangeType(event, "buttonDetails")} />
              <label>Button Content:</label>
              <input value={item.buttonDetails.content} name="content" onChange={event => handleChangeType(event, "buttonDetails")} />
              <label>Button Content Name:</label>
              <input value={item.buttonDetails.contentName} name="contentName" onChange={event => handleChangeType(event, "buttonDetails")} />
              <label>Is Button Internal:</label>
              <label className="switch">
                <input type="checkbox" name="hasButton" checked={item.hasButton} onChange={handleChange} />
                <span className="slider round"></span>
              </label>
              <label>Button Text:</label>
              <input value={item.buttonDetails.buttonText} name="buttonText" onChange={event => handleChangeType(event, "buttonDetails")} />
            </span>
          </span>
          <span>
            <label>News Text:</label>
            {item.articleText.map((d, i) =>

              Array.isArray(d) ? d.map((point, j) => <span className="row"><span className="icon">•</span> <textarea value={point} className="column" rows="5" name="articleText" placeholder="" onChange={event => handleChangeArrayType2(event, i, j)} /><button onClick={() => removeList("articleText", i, j)}>Remove</button></span>) :
                <span className="row"><textarea key={i + "articleText"} value={d} className="column" rows="5" name="articleText" placeholder="" onChange={event => handleChangeArrayType(event, i)} /><button onClick={() => removePara("articleText", i)}>Remove</button></span>
            )}
            {toggle === 'articleText' ? <span></span> : <div><button onClick={() => setToggle("articleText")}>Add New Line</button></div>}
            {toggle === 'articleText' ? <textarea value={content} className="column" rows="5" name="articleText" placeholder="" onChange={handleContent} /> : <span></span>}
            {toggle === 'articleText' ? <div><button onClick={() => addContent("articleText", index)}>Save</button><button onClick={() => setToggle("")}>Remove</button></div> : <span></span>}

            {toggle2 === 'articleText' ? <span /> : <div><button onClick={() => setToggle2("articleText")}>Add New List</button></div>}
            {toggle2 === 'articleText' ? points.map(point => <span className="row"><span className="icon"> •</span> <textarea value={point} className="column" rows="5" name="articleText" placeholder="" onChange={handlePoints} /></span>) : <span></span>}
            {toggle2 === 'articleText' ? <div><textarea value={point} className="column" rows="5" name="articleText" placeholder="" onChange={event => setPoint(event.target.value)} /><button onClick={() => addPoint()}>Add Into List</button></div> : <span />}
            {toggle2 === 'articleText' ? <div><button onClick={() => addPoints("articleText", index)}>I Have Done The List - Save</button><button onClick={() => { setToggle2(""); setPoints([]) }}>Remove</button></div> : <span></span>}

          </span>
          <div className="orderOperation">
            <button onClick={() => setEditSwitch(-1)}>
              {'Cancel'}
            </button>
            <button onClick={() => updateNews(index)}>
              {'Save'}
            </button>
          </div>
        </li>
        :
        <li>
          <h3>{item.title} </h3>
          <div className="column">Desc: {item.desc}</div>
          <div className="column">Event Link: {item.link}</div>
          <div className="column">Date: {item.date}</div>
        </li>
      }
      <div className="orderOperation">
        <button onClick={() => deleteNews(index)}>
          {'Delete'}
        </button>

        {editSwitch === index ?
          <button onClick={() => updateNews(index)}>
            {'Save'}
          </button>
          :
          <button onClick={() => setEditSwitch(index)}>
            {'Edit'}
          </button>
        }
      </div>
    </div>
  ))


  return (
    <div className="ordersContainer">
      <Header title={config.mainTitle} tip={config.subHeading} icon={config.titleIcon} tabs={tabs} selected={tab} />
      <div className="orderList">{newsList}</div>
      <button onClick={() => addNews()}>
        {'Add News'}
      </button>
    </div>
  )
}

const mapStateToProps = ({ news }) => ({
  news: news
})

const mapDispatchToProps = dispatch => bindActionCreators({ sendRequest }, dispatch)

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(News)
